import { Box, Dialog, DialogActions, DialogContent, Stack, Typography } from '@mui/material';
import { MprcContainer, MprcDialogTitleClose, MprcRequestErrorDialog, MprcRequestErrorReport, MprcRequestIndicator } from 'components';
import { ButtonCancel } from 'components/buttons';
import { MprcSwitch } from 'components/MprcSwitch';
import { useTranslation } from 'react-i18next';
import { RegistrationNoticeView } from 'views/lms/student/Registration/components/RegistrationNoticeView';
import { RegistrationViewHeader } from 'views/lms/student/Registration/components/RegistrationViewHeader';
import { ITrainingRegistrationProps, useTrainingRegistrationContext } from 'views/lms/student/Registration/TrainingRegistrationDialog';

export const InternalTrainingRegistrationDlg = (props: ITrainingRegistrationProps) => {

  const { subtitle, immediateRegistration, onClose, mode, readonly } = props;
  const {
    setTraining, setRegisterSubordinates,
    fails, checks, checksFailed, registerSubordinates,
    loading, saving, creatingEnroll, viewError, currentTab,
    ActionButton, training, classrooms, selectedClassroom, classroomId, Content
  } = useTrainingRegistrationContext();
  const { t } = useTranslation("lms");

  return immediateRegistration
    ? (
      <>
        <MprcRequestIndicator visible={saving || creatingEnroll} type="post" message={t("Registration.Training.CreatingEnrollText")} />
        <MprcRequestErrorDialog error={viewError} onClose={() => onClose()} />
      </>
    )
    : (
      <>
        <Dialog
          open
          maxWidth="sm"
          fullWidth
          sx={{ minWidth: (theme) => theme.breakpoints.values.sm }}
          onClose={
            (e, reason) => {
              if (reason == "escapeKeyDown" && readonly) onClose();
            }
          }
        >
          <MprcDialogTitleClose
            title={
              fails.length > 0
                ? t("Registration.Training.RegisterFailTitle")
                : readonly
                  ? t("Registration.Training.InfoTitle")
                  : mode == "enrollManager"
                    ? t("Registration.Training.EnrollUserTitle")
                    : t("Registration.Training.Title")
            }
            subtitle={subtitle}
            shrinkPadding
            onClose={() => onClose(undefined)}
          />

          <DialogContent>
            <MprcRequestIndicator visible={creatingEnroll} type="post" message={t("Registration.Training.CreatingEnrollText")} />
            <MprcRequestIndicator visible={saving} type="post" />
            <MprcRequestIndicator visible={loading} type="request" />
            {viewError && <MprcContainer><MprcRequestErrorReport error={viewError} /></MprcContainer>}

            <Stack direction="column" height="100%">
              <Box>
                <MprcContainer margin="dense">
                  <RegistrationViewHeader
                    training={training}
                    classrooms={classrooms}
                    selectedClassroom={selectedClassroom}
                    readonly={readonly}
                    showClassroomName={classroomId != undefined}
                    interactionLocation={fails.length > 0 ? "none" : "aside"}
                    onChange={(newData) => setTraining(state => ({ ...state!, ...newData }))}
                  />
                </MprcContainer>

                {(classrooms.length <= 1 || currentTab != 0) &&
                  <RegistrationNoticeView
                    training={training}
                    classrooms={classrooms}
                    selectedClassroom={selectedClassroom}
                    readonly={readonly}
                    registerSubordinates={registerSubordinates}
                    registrationChecks={checks}
                  />
                }
              </Box>
              <Box id="content" overflow="hidden">
                {Content}
              </Box>
            </Stack>
          </DialogContent>
          {
            !readonly &&
            <DialogActions>
              <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
                <div>
                  {
                    fails.length == 0 && training?.hasSubordinatesEnabled && checks?.uniqueClassroomUnavailable !== true &&
                    <MprcSwitch
                      label={<Typography variant="captionHeader">{t("Registration.Training.RegisterSubordinatesText")}</Typography>
                      }
                      checked={registerSubordinates}
                      disabled={mode != undefined && mode != "ownUser"}
                      onChange={(e) => setRegisterSubordinates(e.target.checked)}
                    />
                  }
                </div>
                <Stack direction="row" spacing={1}>
                  {
                    (!checksFailed || registerSubordinates) &&
                    <ButtonCancel
                      variant="contained"
                      onClick={() => onClose(undefined)}
                    />
                  }

                  {ActionButton}
                </Stack>
              </Stack>
            </DialogActions>
          }
        </Dialog>
      </>
    );

};
